import React, { useMemo } from 'react'
import { View, StyleSheet } from 'react-native'
import { Text } from '@components'
import { useLanguage } from '@context'

const LEGEND_DEFS = [
  { labelKey: 'graphScreen.legendMe', color: '#2E78B8' },
  { labelKey: 'graphScreen.legendPrivate', color: '#5DA53B' },
  { labelKey: 'graphScreen.legendPro', color: '#2E78B8' },
  { labelKey: 'graphScreen.legendGhost', color: '#999999' },
  { labelKey: 'graphScreen.legendCategory', color: '#CF874B' },
  { labelKey: 'graphScreen.legendHashtag', color: '#9C27B0' },
  { labelKey: 'graphScreen.legendProfession', color: '#E91E63' },
  { labelKey: 'graphScreen.legendNationality', color: '#D39E50' },
  { labelKey: 'graphScreen.legendCity', color: '#00ACC1' },
] as const

export const GraphLegend: React.FC = () => {
  const { t } = useLanguage()
  const items = useMemo(
    () =>
      LEGEND_DEFS.map((d) => ({
        labelKey: d.labelKey,
        label: t(d.labelKey),
        color: d.color,
      })),
    [t],
  )

  return (
    <View style={styles.container}>
      {items.map((item) => (
        <View key={item.labelKey} style={styles.item}>
          <View style={[styles.dot, { backgroundColor: item.color }]} />
          <Text type="bodyExtraSmall" style={styles.label}>{item.label}</Text>
        </View>
      ))}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
    backgroundColor: 'rgba(255,255,255,0.9)',
    borderRadius: 8,
  },
  item: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },
  label: {
    color: '#666',
    fontSize: 10,
  },
})
